const StarDrawing = (
  <path d="M18.0979 5.854C18.6979 4.012 21.3039 4.012 21.9019 5.854L24.0419 12.438C24.1727 12.839 24.4268 13.1884 24.7681 13.4362C25.1093 13.6841 25.5202 13.8177 25.9419 13.818H32.8659C34.8039 13.818 35.6079 16.298 34.0419 17.438L28.4419 21.506C28.1 21.7541 27.8454 22.104 27.7146 22.5057C27.5838 22.9074 27.5836 23.3402 27.7139 23.742L29.8539 30.326C30.4539 32.168 28.3439 33.702 26.7739 32.562L21.1739 28.494C20.8324 28.246 20.4211 28.1125 19.9989 28.1125C19.5768 28.1125 19.1655 28.246 18.8239 28.494L13.2239 32.562C11.6559 33.702 9.54795 32.168 10.1459 30.326L12.2859 23.742C12.4163 23.3402 12.4161 22.9074 12.2853 22.5057C12.1545 22.104 11.8999 21.7541 11.5579 21.506L5.95995 17.44C4.39395 16.3 5.19995 13.82 7.13595 13.82H14.0579C14.48 13.8201 14.8914 13.6867 15.233 13.4388C15.5746 13.1909 15.8291 12.8413 15.9599 12.44L18.0999 5.856L18.0979 5.854Z" />
);

const customStyles = {
  itemShapes: StarDrawing,
  activeFillColor: "#FFCA28",
  inactiveFillColor: "#E0E0E0",
};

export { customStyles };
